export const API_DEV = 'https://dev-apigateway.airportr.com/';
// export const API_DEV_SLA = 'https://portrslaandpricingdevapi.azurewebsites.net/';
export const API_UAT = 'https://uat-apigateway.airportr.com/';
export const API_LIVE = 'https://apigateway.airportr.com/';
// APP Vars
export const API_PATH = process.env.REACT_APP_API_URL;
export const SUBSCRIPTION_KEY = process.env.REACT_APP_SUBSCRIPTION_KEY;
export const MOBILE_API_KEY = process.env.REACT_APP_MOBILE_API_KEY;
export const APP_AUTHORITY = process.env.REACT_APP_AUTHORITY;
export const LOGIN_REDIRECT = process.env.REACT_APP_REDIRECT;
export const POST_REDIRECT = process.env.REACT_APP_POST_REDIRECT;
export const CURRENT_ENV_NAME = process.env.REACT_APP_CURRENT_ENV_NAME;
export const MAP_API_KEY = process.env.REACT_APP_MAP_API_KEY;
const WEB_API_KEY_DEV = process.env.REACT_APP_WEB_API_KEY_DEV;
const WEB_API_KEY_UAT = process.env.REACT_APP_WEB_API_KEY_UAT;
const WEB_API_KEY_LIVE = process.env.REACT_APP_WEB_API_KEY_LIVE;

const ENVIRONMENTS = [
  {
    name: 'DEV',
    value: API_DEV,
    webApiKey: WEB_API_KEY_DEV,
    notificationApi: 'https://pdev-notifications.azurewebsites.net/api/',
  },
  {
    name: 'SLA',
    value: API_DEV,
    webApiKey: WEB_API_KEY_DEV,
    notificationApi: 'https://pdev-notifications.azurewebsites.net/api/',
  },
  {
    name: 'UAT',
    value: API_UAT,
    webApiKey: WEB_API_KEY_UAT,
    notificationApi: 'https://puat-notifications.azurewebsites.net/api/',
  },
  {
    name: 'LIVE',
    value: API_LIVE,
    webApiKey: WEB_API_KEY_LIVE,
    notificationApi: 'https://portrnotifications.azurewebsites.net/api/',
  },
];
export const CURRENT_ENV = ENVIRONMENTS.find((item) => item.name === CURRENT_ENV_NAME);
export const NEXT_ENV =
  CURRENT_ENV_NAME !== 'LIVE'
    ? ENVIRONMENTS[ENVIRONMENTS.findIndex((item) => item.name === CURRENT_ENV_NAME) + 1]
    : null;
export const WEB_API_KEY = CURRENT_ENV.webApiKey;
export const _header = {
  Authorization: '',
  'Ocp-Apim-Subscription-Key': SUBSCRIPTION_KEY,
};

// API path
export const GET_LOGGED_IN_USER = 'ops/api/user/GetLoggedInUser';
export const ACCOUNT_LIST = 'ops/api/user/GetUserList';
export const BOOKING_LIST = 'ops/api/Booking/GetBookingList';
export const GET_BOOKING = 'ops/api/Booking/GetBooking';
export const GET_TRACKINGDATA = 'ops/api/Tracking/GetTrackingData';
export const GET_BOOKING_ACTIVITY_FEED = 'ops/api/Booking/GetActivityFeed';
export const GET_CALL_LOG = 'ops/api/Comms/GetCallLog';
export const GET_MESSAGE_INSTANCES = 'ops/api/Comms/GetMessageInstances';
export const ADD_BOOKING_NOTE = 'ops/api/Booking/AddBookingNote';
export const RESEND_COMMS = 'ops/api/Comms/SendComms';
export const GET_COMMS = 'ops/api/Comms/GETCommsCopy';
export const SEND_EMAIL = 'Comms/api/Comms/SendEmail';
export const ADD_PSP_NOTE = 'ops/api/payment/PayForExcessBag';
export const BOOKING_SUMMARY = 'ops/api/Airport/GetBookingCount';
export const FLIGHT_SUMMARY = 'ops/api/Flight/GetFlightSummary';
export const DRIVER_SUMMARY = 'ops/api/Driver/GetDriverBookingSummary';
export const UNASSIGNED_DRIVER_SUMMARY = 'ops/api/Driver/GetUnassignedDriverBookingSummary';
export const GET_USER_NOTIFICATION = 'ops/api/Notification/GetUserNotifications';
export const GET_NOTIFICATION = 'ops/api/Notification/GetNotifications';
export const GET_PAYMENT_STATUS = 'ops/api/PaymentLink/GetPaymentLinkStatus';
export const GET_PAYMENT_LINK_SUMMARY = 'ops/api/PaymentLink/GetPaymentLinkSummary';
export const DELETE_CUSTOMER = 'ops/api/User/DeactivateUserAccount';
export const BOOKING_PASSPORTS = 'ops/api/Booking/GetBookingPassports';
// admin api's
export const GET_USERS = 'Admin/api/User/GetUsers';
export const ADD_USER = 'Admin/api/User/AddUser';
export const USER_SETTING = 'Admin/api/User/GetUserSettings';
export const ADD_USER_IMAGE = 'Admin/api/Image/AddImageWithUserId';
export const EDIT_USER = 'Admin/api/User/UpdateUser';
export const DISABLE_USER = 'Admin/api/User/DisableUser';
export const GET_ONFLEET_TEAMS = 'Admin/api/User/GetOnfleetTeams';
export const GET_SERVICEABLE_LOCATIONS = 'Admin/api/Airport/GetServiceableLocations';
export const GET_JOB_TYPES = 'Admin/api/Job/GetJobTypes';
export const ADD_BOOKING_IATA = 'Admin/api/CCD/AddIataCode';
// legecy dashboard api's
export const GET_COPY = 'Admin/api/Content/GetBookingContent';
export const SAVE_COPY = 'Admin/api/Content/SaveBookingContent';

export const GET_PROMOTIONS = 'Admin/api/Promotion/GetPromotions';
export const ADD_PROMOTION = 'Admin/api/Promotion/AddPromotion';
export const EDIT_PROMOTION = 'Admin/api/Promotion/UpdatePromotion';
export const SET_PROMOTION_STATUS = 'Admin/api/Promotion/SetPromotionStatus';
export const ADD_BULK_PROMOTIONS = 'Admin/api/Promotion/CreateBatchPromo';

// sla apis
export const GET_AIRPORT_RULES = 'api/AirportZoneRules/GetAirportZoneRules';
export const GET_ZONE_PRICING = 'api/AirportZonePricing/GetAirportZonePricing';

export const UPDATE_AIRPORT_RULES = 'api/AirportZoneRules/UpdateAirportZoneRules';
export const UPDATE_ZONE_PRICING = 'api/AirportZonePricing/UpdateAirportZonePricing';

// log apis
export const GET_BOOKING_LOG = 'Admin/api/Log/GetLogisticsLogData';
export const GET_API_LOG_SUMMARY = 'Admin/api/Log/GetApiLogSummary';
export const GET_API_LOG_DETAIL = 'Admin/api/Log/GetApiLogDetail';

// web Api
export const GET_TOKEN = 'Web/token';
export const UPDATE_CANCEL_LOGISTIC_JOB_STATUS = 'Web/api/Logistics/UpdateCancelledBookingOnfleetStatus';
export const CANCEL_BOOKING = 'Web/api/Admin/CancelBooking';

// airline configuration
export const GET_AIRLINES = 'airlineconfiguration/api/Airline/GetEligibleAirlines';

export const GET_TEXT_FREE_ADDRESSES = 'https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws';
export const GET_LOCATION = 'Web/api/Location/GetLocationByLocationProvider';
// 2FA
export const SEND_ONE_TIME_LOGIN_CODE = 'Web/api/SMS/SendOneTimeLoginCode';
export const VALIDATE_SMS_CODE = 'Web/api/User/ValidateSMSCode';
// app notification
// export const APP_NOTIFICATION = 'http://localhost:7071/api/';
export const APP_NOTIFICATION = CURRENT_ENV.notificationApi;

// filter information
export const PAYMENT_SUMMARY_FILTER_DURATION = 30;

// REDIRECT URL
export const BOOKINGFORM_CANCELATION_URLS = {
  DEV: 'http://devabc.portr.com/my-account/bookings/booking-details?ref=',
  SLA: 'http://devabc.portr.com/my-account/bookings/booking-details?ref=',
  UAT: 'https://puatbookingformv2.airportr.com/my-account/bookings/booking-details?ref=',
  LIVE: 'https://booking.airportr.com/my-account/bookings/booking-details?ref=',
};
export const TRACKING_URLS = {
  DEV: 'http://portrdevtracking.azurewebsites.net/?',
  SLA: 'http://portrdevtracking.azurewebsites.net/?',
  UAT: 'https://puat-tracking.airportr.com/?',
  LIVE: 'http://track.airportr.com/?',
};

export const API_SLA_PRICING = {
  DEV: 'https://dev-apigateway.airportr.com/slaandpricing/',
  UAT: 'https://uat-apigateway.airportr.com/slaandpricing/',
  LIVE: 'https://apigateway.airportr.com/slaandpricing/',
  SLA: 'https://portrslaandpricingdevtestingapi.azurewebsites.net/',
};

export const API_DEV_SLA = API_SLA_PRICING[CURRENT_ENV_NAME] as string;
export const TRACKING_LINK = TRACKING_URLS[CURRENT_ENV_NAME] as string;
export const BOOKINGFORM_CANCELATION_LINK = BOOKINGFORM_CANCELATION_URLS[CURRENT_ENV_NAME] as string;

export const SLA_AIRPORTS = ['GVA', 'LHR', 'ZRH', 'LGW', 'VIE', 'FRA'];
export const SLA_CCD_AIRPORTS = ['GVA', 'ZRH'];

export const SLA_AIRPORT_BOOKINGTYPE_MAPPING = {
  GVA: [
    { name: 'ABC', value: 'ABC' },
    { name: 'CCD', value: 'CarouselCollection' },
  ],
  ZRH: [
    { name: 'ABC', value: 'ABC' },
    { name: 'CCD', value: 'CarouselCollection' },
  ],
  LHR: [{ name: 'ABC', value: 'ABC' }],
  LGW: [{ name: 'ABC', value: 'ABC' }],
  VIE: [{ name: 'ABC', value: 'ABC' }],
  FRA: [{ name: 'ABC', value: 'ABC' }],
};

export const SLA_TERMINALS_BOOKINGTYPE_MAPPING = {
  GVA: [{ name: '1', value: '1' }],
  ZRH: [{ name: '1', value: '1' }],
  LHR: [{ name: '3', value: '3' }],
  LGW: [
    { name: 'N', value: 'N' },
    { name: 'S', value: 'S' },
  ],
  VIE: [{ name: '3', value: '3' }],
  FRA: [{ name: '1', value: '1' }],
};

// Airline logo
export const AIRLINE_LOGOS = {
  AA: 'https://portrlivecdnassets.azureedge.net/images/branding/americanairlines/logo.svg',
  AY: 'https://portrlivecdnassets.azureedge.net/images/branding/finnair/logo.svg',
  BA: 'https://portrlivecdnassets.azureedge.net/images/branding/britishairways/logo.svg',
  CX: 'https://portrlivecdnassets.azureedge.net/images/branding/cathaypacific/logo.svg',
  QF: 'https://portrlivecdnassets.azureedge.net/images/branding/qantas/logo.svg',
  U2: 'https://portrlivecdnassets.azureedge.net/images/branding/easyjet/logo.svg',
  VS: 'https://portrlivecdnassets.azureedge.net/images/branding/virginatlantic/logo.svg',
  LX: 'https://portrlivecdnassets.azureedge.net/images/branding/swiss/swisslogo.svg',
  SQ: 'https://portrlivecdnassets.azureedge.net/images/branding/singapore/singapore_logo.svg',
};
export const AIRLINE_LOGOS_BOARDING_PASS = {
  BA: 'https://portrlivecdnstorage.blob.core.windows.net/dashboardimages/ba_Logo.svg',
  VS: 'https://portrlivecdnstorage.blob.core.windows.net/dashboardimages/virgin_atlantic_logo.svg',
  LX: 'https://portrlivecdnstorage.blob.core.windows.net/dashboardimages/swiss_logo.svg',
  SQ: 'https://portrlivecdnstorage.blob.core.windows.net/dashboardimages/signapore_airlines_logo.svg',
  QF: 'https://portrlivecdnstorage.blob.core.windows.net/dashboardimages/qantas_logo.svg',
  AY: 'https://portrlivecdnstorage.blob.core.windows.net/dashboardimages/finnair_logo.svg',
  U2: 'https://portrlivecdnstorage.blob.core.windows.net/dashboardimages/easyjet_logo.svg',
  CX: 'https://portrlivecdnstorage.blob.core.windows.net/dashboardimages/cathay_pacific_logo.svg',
  AA: 'https://portrlivecdnstorage.blob.core.windows.net/dashboardimages/american_airways_logoAA.svg',
};
export const AIRLINES = [
  {
    id: 1,
    name: 'Aegean',
    value: 'A3',
  },
  {
    id: 2,
    name: 'American Airlines',
    value: 'AA',
  },
  {
    id: 3,
    name: 'Air Canada',
    value: 'AC',
  },
  {
    id: 4,
    name: 'Finnair',
    value: 'AY',
  },
  {
    id: 5,
    name: 'ITA Airways',
    value: 'AZ',
  },
  {
    id: 6,
    name: 'British Airways',
    value: 'BA',
  },
  {
    id: 7,
    name: 'Cathay Pacific',
    value: 'CX',
  },
  {
    id: 8,
    name: 'Delta',
    value: 'DL',
  },
  {
    id: 9,
    name: 'Edelweiss Air',
    value: 'EDW',
  },
  {
    id: 10,
    name: 'Aer Lingus',
    value: 'EI',
  },
  {
    id: 11,
    name: 'Emirates',
    value: 'EK',
  },
  {
    id: 12,
    name: 'KLM Royal Dutch Airline',
    value: 'KL',
  },
  {
    id: 13,
    name: 'Lufthansa',
    value: 'LH',
  },
  {
    id: 14,
    name: 'SWISS',
    value: 'LX',
  },
  {
    id: 15,
    name: 'Austrian',
    value: 'OS',
  },
  {
    id: 16,
    name: 'Qantas',
    value: 'QF',
  },
  {
    id: 17,
    name: 'Brussels Airlines',
    value: 'SN',
  },
  {
    id: 18,
    name: 'Singapore Airlines',
    value: 'SQ',
  },
  {
    id: 19,
    name: 'Thai Airways International',
    value: 'TG',
  },
  {
    id: 20,
    name: 'Turkish Airlines',
    value: 'TK',
  },
  {
    id: 21,
    name: 'Tap Portugal',
    value: 'TP',
  },
  {
    id: 22,
    name: 'easyJet',
    value: 'U2',
  },
  {
    id: 23,
    name: 'United Airlines',
    value: 'UA',
  },
  {
    id: 24,
    name: 'Air Europa',
    value: 'UX',
  },
  {
    id: 25,
    name: 'Virgin Atlantic',
    value: 'VS',
  },
  {
    id: 26,
    name: 'Discover Airlines',
    value: '4Y',
  }
];
//  payment enums
export enum PaymentType {
  'Card',
  'Apple Pay',
  'Google Pay',
}

// roles
export enum USER_ROLES {
  None,
  Admin,
  HeadOfOperations,
  HeadOfDev,
  HeadOfConcierge,
  Customer,
  Concierge,
  Courier,
  Guest,
  SuperUser,
  Partner,
  ExternalAgent,
  SuperAdmin,
}
// language Enums

export const LANGUAGE_MAP = {
  en: 'English',
  fr: 'French',
  de: 'German',
  it: 'Italian',
};

export enum BookingSummaryJobType {
  'acceptance',
  'inject',
  'collection',
  'delivery',
}
